<script setup>
import AristLogo from '@/components/shared/core/AristLogo.vue'
import {useCurrentOrganization} from '@/composables/use-current-organization.js'

//Composables
const {organizationLogoUrl} = useCurrentOrganization()
</script>

<template>
  <div :class="$style.logoWrapper">
    <img
      v-if="organizationLogoUrl"
      :src="organizationLogoUrl"
      :class="$style.organizationLogo"
      alt="Logo"
    >
    <AristLogo
      v-else
      :class="$style.aristLogo"
    />
  </div>
</template>

<style module>
.logoWrapper {
  font-size: 0;
}
.organizationLogo {
  max-height: 2.5rem;
  max-width: 6rem;
}
.aristLogo {
  height: 1.75rem;
}
</style>
